import isSSR from "../../../utils/isSSR";
import { GLOBALNAV_KBB_BASE_URL } from '../mykbb/utils/constants';
import { getClientEnvVariable } from '@kbbsdk/config/clientEnvVariables';
var getLink = function getLink(page) {
  var isIncludeRefUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var refUrl = isIncludeRefUrl && !isSSR() ? "?refUrl=".concat(encodeURIComponent(window.location.href)) : '';
  return "".concat(GLOBALNAV_KBB_BASE_URL, "/account/").concat(page).concat(refUrl);
};
export var SIGN_OUT_URL = getLink('sign-out', true);
export var SIGN_IN_URL = getLink('sign-in', true);
export var CREATE_ACCOUNT_URL = getLink('sign-up');
export var MY_PROFILE_URL = getLink('profile');
export var NEW_CAR_SEARCH_URL = getLink('cars');
export var MY_CARS_URL = getLink('mycars');
export var DEALER_REVIEWS_URL = getLink('dealer-reviews');
export var MANAGE_MY_AD = process.env.CONFIG === 'nonprod' ? 'https://test.autotrader.com/sell-my-car/manage-ad' : 'https://www.autotrader.com/sell-my-car/manage-ad';
export var getWebComponentUrl = function getWebComponentUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$userwcbranch = _ref.userwcbranch,
    userwcbranch = _ref$userwcbranch === void 0 ? 'master' : _ref$userwcbranch;
  return getClientEnvVariable('CONFIG') === 'nonprod' || process.env.CONFIG === 'nonprod' ? "https://use1-user-webcomponents-node-".concat(userwcbranch, ".awscsusernp.kbb.com/build/node.esm.js?v=").concat(Date.now()) : "https://use1-user-webcomponents-node-".concat(userwcbranch, ".awscsuser.kbb.com/build/node.esm.js?v=").concat(Date.now());
};